import Icon from './AdHeadline.icon';

export default {
  Icon,
  // getWordCounts: (document) => {
  //   return [{
  //     title: 'Headline',
  //     value: document.content,
  //   }];
  // },
};
